var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49516 3.49585C8.67113 3.4366 8.86166 3.4366 9.03763 3.49585L16.9446 6.15816C16.9665 6.16529 16.9882 6.1733 17.0094 6.18216C17.0668 6.20606 17.1207 6.23586 17.1705 6.27072C17.298 6.35995 17.4021 6.48478 17.466 6.63688C17.4842 6.68018 17.4989 6.72518 17.5099 6.77146C17.5269 6.84329 17.5342 6.91553 17.5326 6.98667V17.0333C17.5326 17.3982 17.2996 17.7224 16.9538 17.8388L9.05797 20.4975C8.96705 20.5307 8.86887 20.5488 8.76647 20.5488C8.66476 20.5488 8.56722 20.5309 8.47682 20.4981L0.578988 17.8388C0.233151 17.7224 0.000230949 17.3982 0.000230949 17.0333V6.98665C-0.001439 6.9153 0.0059239 6.84284 0.0230827 6.7708C0.0339907 6.72475 0.0486714 6.67997 0.0668374 6.63688C0.155753 6.42514 0.322642 6.26623 0.522149 6.18267C0.543796 6.1736 0.565827 6.16542 0.588184 6.15816L8.49516 3.49585ZM9.61647 18.5156L15.8326 16.4226V8.14991L9.61647 10.243V18.5156ZM7.91647 10.243V18.5157L1.70023 16.4226V8.14991L7.91647 10.243ZM8.76639 5.1983L14.0189 6.96683L8.76639 8.7354L3.51393 6.96683L8.76639 5.1983Z",
    fill: "#576473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.f8f4584028d7dd2d1fc264aedcc4208f.svg";
export { ForwardRef as ReactComponent };